/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Session Process Handlers
 *
 * All session-related query and mutation handlers
 */

import { handleRequest } from './config'
import { mockData } from '../mocks'
import { ApiResponse, Session } from '../types'

// ========================================
// QUERY HANDLERS
// ========================================

/**
 * Get all sessions with optional filters
 */
export const getSessions = async (_filters?: Record<string, any>): Promise<ApiResponse<Session[]>> => {
  return handleRequest(
    () => Promise.resolve({ data: mockData.sessions, success: true } as ApiResponse<Session[]>),
    async () => {
      // TODO: Implement cloud function for sessions
      return { data: [], success: true }
    }
  )
}

/**
 * Get a single session by ID
 */
export const getSession = async (id: string): Promise<ApiResponse<Session>> => {
  return handleRequest(
    () => {
      const session = mockData.sessions.find((s) => s.id === id)
      return Promise.resolve({
        data: session!,
        success: !!session,
        error: session ? undefined : 'Session not found'
      } as ApiResponse<Session>)
    },
    async () => {
      // TODO: Implement cloud function for single session
      return { data: {} as Session, success: false }
    }
  )
}

/**
 * Get sessions for sprint and team (used in report flow Step 2)
 */
export const getSessionsForSprintAndTeam = async (
  sprintIds: string[],
  teamIds: string[],
  state?: any
): Promise<ApiResponse<any[]>> => {
  return handleRequest(
    async () => Promise.resolve({ data: [], success: true } as ApiResponse<any[]>),
    async () => {
      const { loadCloudFunctionsHandler } = await import('../handlers')
      const cloudFunctions = await loadCloudFunctionsHandler()
      const stateToUse = state || ({ user: { id: '' } } as any)
      const result = await cloudFunctions.getSessionForGroupAndTeam(sprintIds, teamIds, stateToUse)
      return {
        data: result.sessions || [],
        success: result.success,
        error: result.error
      } as ApiResponse<any[]>
    }
  )
}
